import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {inject, Injectable} from "@angular/core";
import {catchError, Observable} from "rxjs";
import {GridGetService, GridServiceParams, GridServiceResponse} from "src/app/shared/model/page-grid";
import {removeEmptyParams} from "src/infrastructure/helper/remove-empty-params";
import {FinanceFilterModel} from "../models/finance-filter-model";
import {FinanceFilterModalService} from "./finance-filter-modal.service";
import {GetTravelTypeSalesActivityReportResponse} from "../models/travel-type-sales-activity-report-response";

@Injectable({
  providedIn: 'root'
})

export class SalesActivityTravelTypeService implements GridGetService<GetTravelTypeSalesActivityReportResponse> {
  private readonly baseUrl = 'dbov2/sales-activity-report/by-travel-type';
  private readonly http = inject(HttpClient);
  public financeFilters: FinanceFilterModel= {} as FinanceFilterModel;

  constructor(
    private financeFilterModalService: FinanceFilterModalService
    ) {
      this.financeFilterModalService.getFilters().subscribe((filter: FinanceFilterModel) => {
          Object.assign(this.financeFilters, filter);
      });
    }

  public getCurrentFilters(): FinanceFilterModel {
    return this.financeFilters;
  }

  getItems({page, sort} : GridServiceParams): Observable<GridServiceResponse<GetTravelTypeSalesActivityReportResponse>>  {
    const effectiveFilters = this.financeFilters;
    
    const params:Record<string, string | number | boolean | string[] | number[]> = {
      pageSize:  page?.pageSize || 25,
      pageNumber : (page?.pageIndex || 0) + 1,
      propertyName: sort?.active || '',
      orderKey: sort?.direction || '',

      issueDateFrom: effectiveFilters?.IssueDateFrom ? new Date(effectiveFilters.IssueDateFrom).toISOString() : '',
      issueDateTo: effectiveFilters?.IssueDateTo ? new Date(effectiveFilters.IssueDateTo).toISOString() : '',
      submitToList: effectiveFilters?.SubmitToList || [],
      travelTypeIds: effectiveFilters?.TravelTypeIds || [],
      dataSourceId: effectiveFilters?.DataSourceId ?? '',
      branchIds: effectiveFilters?.BranchIds || []
    };

    removeEmptyParams(params);
    
    return this.http.get<GridServiceResponse<GetTravelTypeSalesActivityReportResponse>>(`${this.baseUrl}`, { params: {...params} })
    .pipe(catchError((error:HttpErrorResponse)=>{
        throw new Error(error?.message || 'Server error');
    }));
  }
}